"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WysdomArticleService = void 0;
const operators_1 = require("rxjs/operators");
const http_1 = require("@angular/common/http");
class WysdomArticleService {
    constructor(http) {
        this.http = http;
    }
    getArticlesByTopic(searchQuery, lob) {
        this.setWysdomArticleURL();
        const body = {
            c: this.getCompanyId(lob),
            searchLanguage: 'en',
            searchQuery,
            lob,
            maxResults: '100',
            primaryAcct: 'articlesByTopic'
        };
        return this.http.post(this.wysdomArticleUrl, body).pipe(operators_1.map((res) => {
            // const result = res.json();
            const result = res;
            return result;
        }));
    }
    setWysdomArticleURL() {
        const environment = this.getWysdomEnvironment();
        if (environment === 'PROD') {
            this.wysdomArticleUrl = 'https://cspire.wysdom.com/ws/web/search';
        }
        else {
            this.wysdomArticleUrl = 'https://cspire-uat.wysdom.com/ws/web/search';
        }
    }
    getWysdomEnvironment() {
        let env;
        const hostName = window.location.host;
        if (hostName.indexOf('test-www.cspire.com') > -1
            || hostName.indexOf('int-www.cspire.com') > -1
            || hostName.indexOf('localhost') > -1) {
            env = 'UAT';
        }
        else {
            env = 'PROD';
        }
        return env;
    }
    getCompanyId(lob) {
        let companyId;
        switch (lob) {
            case 'WebFTTHSupport':
                companyId = '201';
                break;
            case 'WebAFBSupport':
                companyId = '202';
                break;
            default:
                companyId = '20';
        }
        return companyId;
    }
}
exports.WysdomArticleService = WysdomArticleService;
//# sourceMappingURL=dynamic-articles.service.js.map